import { registerComponent } from 'lib/react_on_rails';

import LocationDetail from 'participant/apply/location_detail';
import { PartnerSchedulingAlert } from 'participant/apply/partner_scheduling_alert';
import TechnicalRequirements from 'participant/apply/technical_requirements';
import { ProjectInterviewInfo } from 'researcher/project_interview_info/project_interview_info';

// oxlint-disable-next-line local-rules/css_modules
import 'participant/apply/apply.css';

registerComponent('LocationDetail', LocationDetail);
registerComponent('PartnerSchedulingAlert', PartnerSchedulingAlert);
registerComponent('ProjectInterviewInfo', ProjectInterviewInfo);
registerComponent('TechnicalRequirements', TechnicalRequirements);
